import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';

import { LIMITS } from '@pletly/shared';
import { usePremium } from '%context/Premium';
import { GetCreatedAccounts } from './__generated__/GetCreatedAccounts';
import { GET_CREATED_ACCOUNTS } from './createdAccounts.graphql';

export const useCreateAccount = () => {
	const { navigate } = useNavigation();
	const { type: premiumType, status: premiumStatus } = usePremium();
	const { data } = useQuery<GetCreatedAccounts>(GET_CREATED_ACCOUNTS, {
		fetchPolicy: 'network-only',
	});
	const createdAccountsCount = data?.currentUser.superPalOf.length || 0;

	const goToCreateAccount = useCallback(() => {
		const canCreate =
			premiumStatus === 'feature_disabled' ||
			createdAccountsCount < LIMITS.maxCreatedCareReceiverAccounts[premiumType];

		if (!canCreate) {
			return navigate('Paywall');
		}

		return navigate('CreateAccount');
	}, [createdAccountsCount, premiumType, premiumStatus, navigate]);

	return { goToCreateAccount };
};
